import { render, staticRenderFns } from "./GameResultModal.vue?vue&type=template&id=783ae1f9&scoped=true&"
import script from "./GameResultModal.vue?vue&type=script&lang=js&"
export * from "./GameResultModal.vue?vue&type=script&lang=js&"
import style0 from "./GameResultModal.vue?vue&type=style&index=0&id=783ae1f9&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "783ae1f9",
  null
  
)

export default component.exports